module.exports = __webpack_public_path__ + "static/media/intelistyle_background.56ba4ce0.jpeg";